export const ADMIN_VIEW = -1
